module.exports = __webpack_public_path__ + "images/140_640.jpg";